import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <main id="main" className="min-h-dvh grid place-items-center px-4">
      <div className="glass rounded-3xl p-10 text-center">
        <p className="font-display text-6xl font-bold text-brand-600">404</p>
        <h1 className="mt-3 font-display text-2xl font-bold">페이지를 찾을 수 없어요.</h1>
        <Link to="/" className="btn btn-primary mt-6 inline-flex">
          <i className="fa-solid fa-house" aria-hidden="true" /> 홈으로
        </Link>
      </div>
    </main>
  );
}
